/**
 * enum for setting block direction, used by setDirection API
 */
// eslint-disable-next-line etc/no-const-enum
export const enum Direction {
    /**
     * Left to right
     */
    LeftToRight,

    /**
     * Right to left
     */
    RightToLeft,
}
